import STCEligibleLocations from './STCEligibleLocations';

export default STCEligibleLocations;
